// extracted by mini-css-extract-plugin
module.exports = {"title-section":"_3Z4mCvMufw","titleSection":"_3Z4mCvMufw","not-available":"_1iZ7iHV7SK","notAvailable":"_1iZ7iHV7SK"};
    if(module.hot) {
      // 1614934721332
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  